module.exports = __webpack_public_path__ + "img/guide_5_3.8e6a2635.svg";